import type { Feature, FeatureModule } from '../../../types';
import { featureList } from '../../helpers';
import { CRM_EVENTS_FEATURE_GROUP } from './group';

export const CRM_EVENTS_FEATURES = {
  READ: {
    guid: 'c7d2e5b8-1a43-4c69-8b27-6e9f1d2a0500',
    name: 'crm_events:read',
    description: 'View the CRM events page',
    action: 'read',
    product: 'crm',
    parentGuid: CRM_EVENTS_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { CRM_EVENTS_FEATURE_GROUP } from './group';

export const CRM_EVENTS_MODULE: FeatureModule = {
  product: 'crm',
  groups: [CRM_EVENTS_FEATURE_GROUP],
  features: featureList(CRM_EVENTS_FEATURES),
};
